import React, { Component, Fragment } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
import FilterItem from '../components/filter-item-mobile'
import { setCategory } from '../components/api'

import chevrondown from '../../assets/icon/chevron-down.svg'

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 15vh;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(125, 125, 125, 0.9);
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  border-top: 1px solid #efefef;
  z-index: 3;
`

class Filter extends Component {
  state = {
    categories: [
      { label: 'Todos', label_en: 'All', filter: 'all', marked: true },
      {
        label: 'Residencial',
        label_en: 'Residential',
        filter: 'residencial',
        marked: false
      },
      {
        label: 'Comercial',
        label_en: 'Commercial',
        filter: 'comercial',
        marked: false
      },
      {
        label: 'Público',
        label_en: 'Public',
        filter: 'publico',
        marked: false
      },
      {
        label: 'Histórico',
        label_en: 'Historical',
        filter: 'historico',
        marked: false
      }
    ],
    open: false,
    filterLabel: ''
  }

  componentWillMount () {
    const language = window.location.search
    const filterLabel = language === '?lang=en' ? 'All' : 'Todos'

    this.setState({ language, filterLabel })
  }

  _filter (category, index) {
    let categories = this.state.categories
    categories.map((category, categoryIndex) => {
      category.marked = categoryIndex === index
    })
    this.setState({ categories, filterLabel: this.state.language === '?lang=en' ? category.label_en : category.label, open: false })
    this.props.filterBy(category.filter)
    setCategory(category)
  }

  render () {
    const { categories, open, filterLabel } = this.state
    return (
      <Fragment>
        {open && (
          <Wrapper>
            {categories.map((category, index) => (
              <FilterItem
                key={index}
                label={this.state.language === '?lang=en' ? category.label_en : category.label}
                marked={category.marked}
                onClick={() => this._filter(category, index)}
              />
            ))}
          </Wrapper>
        )}
        {!open && (
          <div
            style={{
              display: 'flex',
              alignItems: `center`,
              position: `fixed`,
              backgroundColor: `white`,
              top: `12vh`,
              paddingLeft: `12vw`,
              width: `100vw`,
              height: `7vh`,
              fontFamily: `OpensansBold`,
              fontSize: `3.2vw`,
              color: `gray`,
              pointerEvents: `auto`,
              zIndex: 2
            }}
            onClick={() => this.setState({ open: true })}>
            {filterLabel}
            <img
              src={chevrondown}
              style={{
                display: `block`,
                marginLeft: `auto`,
                marginRight: `7.5vw`,
                marginTop: `3.5vh`,
                opacity: `0.34`,
                width: `4vw`,
                height: `4vw`
                // backgroundColor: `red`,
              }}
            />
          </div>
        )}
      </Fragment>
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/filter-mobile.js